/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Toast_CreatedInputs */

const vi_grower_area_camera_toast_created = /** @type {(inputs: Grower_Area_Camera_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thêm camera`)
};

/**

* @param {Grower_Area_Camera_Toast_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_toast_created = /** @type {((inputs?: Grower_Area_Camera_Toast_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Toast_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_toast_created(inputs)
});